<div class="bg-m1 flex h-full cursor-default flex-col">
  <div class="mx-6 mb-6 mt-8 flex h-2 flex-grow flex-col">
    <div class="flex h-11 flex-row items-center justify-start">
      <div
        data-cy="projectTeamTitle"
        class="text-s1 flex select-none text-2xl font-semibold"
        >{{ pageTitle }}
      </div>

      <div
        class="ml-10"
        tp="Admin role required"
        [tpIsEnabled]="isAdmin === false"
      >
        <button
          data-cy="projectTeamInviteMemberButton"
          class="text-m0 h-11 flex-shrink-0 select-none rounded px-5 py-2 text-base font-medium focus:outline-none"
          type="submit"
          [ngClass]="{
            'bg-m600': isAdmin === true,
            'bg-s400 cursor-default': isAdmin === false
          }"
          (click)="inviteMember()"
          [disabled]="isAdmin === false"
          >Invite Member</button
        >
      </div>
    </div>

    <div class="bg-m0 mb-4 mt-6 flex-grow overflow-auto rounded shadow">
      <ng-scrollbar
        [orientation]="'auto'"
        [visibility]="'hover'"
        [appearance]="'compact'"
      >
        <div class="text-s1 mx-5 mt-8">
          <table class="divide-s500 min-w-full divide-y">
            <thead>
              <tr class="h-12 text-sm">
                <th class="select-none"></th>
                <th class="select-none"></th>
                <th class="select-none text-left">Email</th>
                <!-- <th class="select-none text-left">Alias</th> -->
                <th class="select-none text-left">Name</th>
                <th class="select-none text-center">Project Admin</th>
                <th class="select-none text-center">Files Editor</th>
                <th class="select-none text-center">Explorer</th>
                <th class="select-none"></th>
                <th class="select-none text-left">Access Roles</th>
                <th class="select-none text-center">Givens</th>
                <th class="select-none"></th>
              </tr>
            </thead>

            <tbody class="divide-s300 divide-y">
              <tr *ngIf="members?.length === 0"> </tr>

              <tr
                *ngFor="
                  let member of members
                    | paginate
                      : {
                          id: 'members',
                          itemsPerPage: perPage,
                          currentPage: currentPage,
                          totalItems: total
                        };
                  let i = index
                "
                class="h-16"
              >
                <td class="w-[80px]">
                  <ng-template #templateRemoveMember>
                    <div *ngIf="isAdmin === false">Admin role required</div>

                    <div *ngIf="isAdmin === true && member.memberId === userId"
                      >Only another admin can remove you from project
                      members</div
                    >
                  </ng-template>

                  <div
                    [tp]="templateRemoveMember"
                    [tpIsEnabled]="
                      member.memberId === userId || isAdmin === false
                    "
                  >
                    <button
                      data-cy="projectTeamRemoveMemberButton"
                      class="text-s1 ml-5 h-9 w-9 rounded focus:outline-none"
                      [ngClass]="{
                        'cursor-default':
                          member.memberId === userId || isAdmin === false,
                        'hover:bg-m200':
                          member.memberId !== userId && isAdmin !== false
                      }"
                      [disabled]="
                        member.memberId === userId || isAdmin === false
                      "
                      (click)="removeMember(member)"
                    >
                      <div
                        class="flex justify-center"
                        [ngClass]="{
                          'text-s400':
                            member.memberId === userId || isAdmin === false
                        }"
                      >
                        <m-delete-icon></m-delete-icon>
                      </div>
                    </button>
                  </div>
                </td>

                <td class="w-[60px]">
                  <div class="flex">
                    <button
                      class="bg-m200 h-10 w-10 rounded-full text-base tracking-wider focus:outline-none"
                      [ngClass]="{
                        'cursor-default': !member.avatarSmall
                      }"
                      (click)="
                        showPhoto({
                          memberId: member.memberId,
                          firstName: member.firstName,
                          lastName: member.lastName,
                          alias: member.alias,
                          avatarSmall: member.avatarSmall
                        })
                      "
                      [disabled]="!member.avatarSmall"
                    >
                      <m-avatar
                        [avatar]="member.avatarSmall"
                        [initials]="member.initials"
                      ></m-avatar>
                    </button>
                  </div>
                </td>

                <td data-cy="projectTeamMemberEmailData" class="w-96 text-base">
                  {{ member.email }}
                </td>

                <!-- <td class="w-64 text-base">{{ member.alias }}</td> -->

                <td class="w-[300px] text-base">{{ member.fullName }}</td>

                <td class="w-48">
                  <div class="flex justify-center">
                    <ng-template #templateChangeAdminStatus>
                      <div *ngIf="isAdmin === false">Admin role required</div>

                      <div
                        *ngIf="isAdmin === true && member.memberId === userId"
                        >Only another admin can change your admin status</div
                      >
                    </ng-template>

                    <div
                      class="w-fit"
                      [tp]="templateChangeAdminStatus"
                      [tpIsEnabled]="
                        isAdmin === false || member.memberId === userId
                      "
                    >
                      <button
                        data-cy="projectTeamIsAdminButton"
                        class="text-m0 flex h-5 w-5 items-center justify-center rounded border-2 focus:outline-none"
                        [ngClass]="{
                          'bg-m600':
                            member.isAdmin === true &&
                            isAdmin === true &&
                            member.memberId !== userId,
                          'bg-s400 cursor-default':
                            member.isAdmin === true &&
                            (isAdmin === false || member.memberId === userId),
                          'border-m600': isAdmin === true,
                          'border-s400 cursor-default':
                            member.memberId === userId || isAdmin === false
                        }"
                        (click)="isAdminChange($event, i)"
                        [disabled]="
                          member.memberId === userId || isAdmin === false
                        "
                      >
                        <m-check-icon *ngIf="member.isAdmin"></m-check-icon>
                      </button>
                    </div>
                  </div>
                </td>

                <td class="w-48">
                  <div class="flex justify-center">
                    <div
                      tp="Admin role required"
                      [tpIsEnabled]="isAdmin === false"
                    >
                      <button
                        data-cy="projectTeamIsEditorButton"
                        class="text-m0 flex h-5 w-5 items-center justify-center rounded border-2 focus:outline-none"
                        [ngClass]="{
                          'bg-m600':
                            member.isEditor === true && isAdmin === true,
                          'bg-s400 cursor-default':
                            member.isEditor === true && isAdmin === false,
                          'border-m600': isAdmin === true,
                          'border-s400 cursor-default': isAdmin === false
                        }"
                        (click)="isEditorChange($event, i)"
                        [disabled]="isAdmin === false"
                      >
                        <m-check-icon *ngIf="member.isEditor"></m-check-icon>
                      </button>
                    </div>
                  </div>
                </td>

                <td class="w-48">
                  <div class="flex justify-center">
                    <div
                      tp="Admin role required"
                      [tpIsEnabled]="isAdmin === false"
                    >
                      <button
                        data-cy="projectTeamIsExplorerButton"
                        class="text-m0 flex h-5 w-5 items-center justify-center rounded border-2 focus:outline-none"
                        [ngClass]="{
                          'bg-m600':
                            member.isExplorer === true && isAdmin === true,
                          'bg-s400 cursor-default':
                            member.isExplorer === true && isAdmin === false,
                          'border-m600': isAdmin === true,
                          'border-s400 cursor-default': isAdmin === false
                        }"
                        (click)="isExplorerChange($event, i)"
                        [disabled]="isAdmin === false"
                      >
                        <m-check-icon *ngIf="member.isExplorer"></m-check-icon>
                      </button>
                    </div>
                  </div>
                </td>

                <td class="w-24"></td>

                <td class="w-64">
                  <div class="flex flex-row items-center">
                    <div
                      [tp]="templateAddRole"
                      [tpIsEnabled]="
                        isAdmin === false || member.roles.length >= roles.length
                      "
                    >
                      <ng-template #templateAddRole>
                        <div *ngIf="isAdmin === false">Admin role required</div>

                        <div
                          *ngIf="
                            isAdmin === true &&
                            member.roles.length >= roles.length
                          "
                          >All project roles are already selected for the
                          current member (or the Project has no roles)</div
                        >
                      </ng-template>

                      <button
                        data-cy="projectTeamAddRoleButton"
                        class="flex h-8 w-8 items-center justify-center rounded focus:outline-none"
                        [ngClass]="{
                          'text-s400 cursor-default':
                            isAdmin === false ||
                            member.roles.length >= roles.length,
                          'text-m600 hover:bg-m200':
                            isAdmin === true &&
                            member.roles.length < roles.length
                        }"
                        (click)="addRole(member, i)"
                        [disabled]="
                          isAdmin === false ||
                          member.roles.length >= roles.length
                        "
                      >
                        <div>
                          <m-add-icon></m-add-icon>
                        </div>
                      </button>
                    </div>

                    <div class="my-3 ml-5 flex flex-col">
                      <div *ngFor="let role of member.roles; let n = index">
                        <div class="flex flex-row items-center text-base">
                          <div
                            class="truncate rounded bg-blue-100 px-2 text-blue-800"
                            >{{ role }}</div
                          >
                          <div
                            tp="Admin role required"
                            [tpIsEnabled]="isAdmin === false"
                            class="ml-3"
                          >
                            <button
                              data-cy="projectTeamRemoveRoleButton"
                              class="flex h-8 w-8 items-center justify-center rounded focus:outline-none"
                              [ngClass]="{
                                'text-s1 hover:bg-m200': isAdmin === true,
                                'text-s300 cursor-default': isAdmin === false
                              }"
                              (click)="removeRole(member, i, n)"
                              [disabled]="isAdmin === false"
                            >
                              <div>
                                <m-delete-icon></m-delete-icon>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>

                <td class="w-32">
                  <div class="flex justify-center">
                    <button
                      data-cy="projectTeamShowGivensButton"
                      class="border-s400 text-s500 hover:bg-s100 w-[73px] select-none rounded border px-3 py-2 text-base leading-3 shadow-sm focus:outline-none"
                      type="button"
                      (click)="getMemberGivens(member)"
                      >Show</button
                    >
                  </div>
                </td>

                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-scrollbar>
    </div>

    <pagination-controls
      class="mt-3 flex justify-center"
      (pageChange)="getMembers($event)"
      id="members"
    ></pagination-controls>
  </div>
</div>

<div *ngIf="userId$ | async"></div>
<div *ngIf="projectId$ | async"></div>
<div *ngIf="isAdmin$ | async"></div>
<div *ngIf="members$ | async"></div>
<div *ngIf="total$ | async"></div>
<div *ngIf="roles$ | async"></div>
